// removed by extract-text-webpack-plugin
module.exports = {"container":"_checkout-survey__container__1Nbod","modalHeader":"_checkout-survey__modalHeader__2lvlN","buttonWrapper":"_checkout-survey__buttonWrapper__2xxz5","formClass":"_checkout-survey__formClass__2YW24","labelClass":"_checkout-survey__labelClass__3tGAb","textAreaLabel":"_checkout-survey__textAreaLabel__2INCk","desktopHidden":"_checkout-survey__desktopHidden__hdAym","textarea":"_checkout-survey__textarea__1JKyT"};


//////////////////
// WEBPACK FOOTER
// ./assets/scss/checkout/subviews/_checkout-survey.scss
// module id = 3104
// module chunks = 62